import { exportExcelFile } from "utils/exportExcelFile";

export const exportVehicleHiringEntriesExcel = ({ entries, startDate, endDate }) => {
    if (!entries?.length) return;

    const exportData = entries.map((row) => {
        const sortedDates = [...(row?.hiringDates || [])].sort(
            (a, b) => new Date(a) - new Date(b)
        );
        const hiringDatesLabel = sortedDates
            .map((d) =>
                new Date(d).toLocaleDateString(undefined, {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                })
            )
            .join(", ");

        return {
            "Hiring Date": hiringDatesLabel || "N/A",
            "Vehicle Number": row?.vehicleRegistrationNumber?.registration_number || "N/A",
            Source: row?.sourceBranch?.name || "N/A",
            Destination: row?.destinationBranch?.name || "N/A",
            "Approve / Submitted To": row?.responsibleUser?.name || "N/A",
            Fare: row?.totalFare ?? row?.hiringFare ?? "N/A",
        };
    });

    const rangeLabel = `${startDate || "All"}_to_${endDate || "All"}`;
    const fileName = `Vehicle Hiring Entry ${rangeLabel}`;

    exportExcelFile({
        sheetData: exportData,
        fileName,
    });
};